<template>
    <div class="Info">
        <div class="InfoTop">
            <!-- <div class="InfoTopBtn BgBlue" @click="handleProjectClick" v-if="showProjectBtn">项目申请</div> -->
            <div class="InfoTopBtn BgBlue" @click="handleProjectClick">项目申请</div>
        </div>
        <div class="PublishCont">
            <el-table :data="Data" style="width: 100%">
                <el-table-column prop="id" label="序号" width="60"></el-table-column>
                <el-table-column prop="title" label="项目名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="project_code" label="项目编号" width="140" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.project_code || '-' }}</template>
                </el-table-column>
                <el-table-column prop="project_type" label="项目类型" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.user_group_id === 6 ? '学历教育' : '继续教育' }}
                    </template>
                </el-table-column>
                <el-table-column prop="start_date" label="开始时间" width="110"></el-table-column>
                <el-table-column prop="end_date" label="结束时间" width="110">
                    <template slot-scope="scope">
                        {{ scope.row.end_date || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="rejection" label="驳回原因" min-width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.rejection || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="ToggleLock(scope.row)">详情</el-button>
                        <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="PageDis" v-if="Data.length > 0">
            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                :hide-on-single-page="false"></el-pagination>
        </div>
        <!-- 项目类型选择弹窗 -->
        <el-dialog title="选择项目类型" :visible.sync="showTypeDialog" width="30%" :show-close="true">
            <div class="project-type-select">
                <el-radio-group v-model="selectedProjectType">
                    <el-radio :label="6">学历教育项目</el-radio>
                    <el-radio :label="7">继续教育项目</el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showTypeDialog = false">取消</el-button>
                <el-button type="primary" @click="handleTypeSelect">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="PublishBlon" :width="Wid" :show-close="false" @close="LockBlon = false">
            <div class="CommDig">
                <!-- 学历教育项目详情查看模式 -->
                <div v-if="LockData.user_group_id === 6 && LockBlon">
                    <div class="DigItem">
                        <div class="DigTit">专业名称</div>
                        <div class="DigCon">{{ LockData.title }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">专业介绍</div>
                        <div class="DigCon">{{ LockData.synopsis }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">开始时间</div>
                        <div class="DigCon">{{ LockData.start_date }}</div>
                    </div>
                    <div class="DigItem" v-if="LockData.img">
                        <div class="DigTit">图片</div>
                        <div class="DigCon">
                            <img class="LockImg" :src="$Global.CommImgHttp + LockData.img" alt=""
                                @click="OpenLock(LockData.img)">
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <div class="DigCon" v-html="LockData.content"></div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">驳回原因</div>
                        <div class="DigCon">{{ LockData.rejection || '-' }}</div>
                    </div>
                </div>

                <!-- 学历教育项目申请编辑模式 -->
                <div v-if="(!LockBlon && !LockData.user_group_id) || educationEditMode">
                    <div class="DigItem">
                        <div class="DigTit">专业名称</div>
                        <input type="text" v-model="SetData.title">
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">专业介绍</div>
                        <input type="text" v-model="SetData.synopsis">
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">开始时间</div>
                        <el-date-picker 
                            v-model="SetData.start_time" 
                            type="date" 
                            placeholder="选择项目开始时间" 
                            style="width: calc(100% - 85px); padding: 0">
                        </el-date-picker>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">文件上传</div>
                        <div class="upload-container">
                            <el-upload 
                                action="none" 
                                :show-file-list="false" 
                                :http-request="UpFile">
                                <div class="StepCommFileBtn">上传</div>
                            </el-upload>
                            <div class="StepCommFileLock" v-if="SetData.img" @click="OpenLock(SetData.img)">查看</div>
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <quill-editor 
                            class="Wid500" 
                            v-model="SetData.content" 
                            ref="myQuillEditor"
                            :options="editorOption">
                        </quill-editor>
                    </div>
                </div>

                <!-- 继续教育项目详情 -->
                <div v-if="LockData.user_group_id === 7 && LockBlon">
                    <div class="form-section">
                        <div class="section-title">基础信息</div>
                        <div class="DigItem">
                            <div class="DigTit">机构名称</div>
                            <div class="DigCon">{{ companyName || '-' }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">项目名称</div>
                            <div class="DigCon">{{ LockData.title }}</div>
                        </div>
                        <div class="DigItem" v-if="LockData.project_code">
                            <div class="DigTit">项目编号</div>
                            <div class="DigCon">{{ LockData.project_code }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">项目类型</div>
                            <div class="DigCon">{{ getCourseCategoryText(LockData.course_category) }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">授课类型</div>
                            <div class="DigCon">{{ getProjectTypeText(LockData.project_type) }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">项目周期</div>
                            <div class="DigCon">{{ LockData.start_date }} 至 {{ LockData.end_date }}</div>
                        </div>
                        <div class="DigItem" v-if="LockData.project_application">
                            <div class="DigTit">项目申请表</div>
                            <div class="DigCon"><el-button type="text" @click="OpenLock(LockData.project_application)">查看PDF</el-button></div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">收费标准</div>
                            <div class="DigCon">{{ LockData.fee }} 元/人</div>
                        </div>
                        <div class="DigItem" v-if="LockData.cost_structure">
                            <div class="DigTit">成本构成说明</div>
                            <div class="DigCon"><el-button type="text" @click="OpenLock(LockData.cost_structure)">查看PDF</el-button></div>
                        </div>
                        <div class="DigItem" v-if="LockData.refund_policy">
                            <div class="DigTit">退费机制说明</div>
                            <div class="DigCon"><el-button type="text" @click="OpenLock(LockData.refund_policy)">查看PDF</el-button></div>
                        </div>
                        <div class="DigItem" v-if="LockData.emergency_plan">
                            <div class="DigTit">应急预案</div>
                            <div class="DigCon"><el-button type="text" @click="OpenLock(LockData.emergency_plan)">查看PDF</el-button></div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">驳回原因</div>
                            <div class="DigCon">{{ LockData.rejection || '-' }}</div>
                        </div>
                    </div>

                    <!-- 课程信息 -->
                    <div class="form-section" v-if="LockData.course && LockData.course.length">
                        <div class="section-title">课程大纲</div>
                        <el-table :data="LockData.course" border style="width: 100%">
                            <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                            <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                            <el-table-column prop="content" label="课程内容" width="180"></el-table-column>
                            <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                            <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                            <el-table-column prop="remark" label="备注"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 师资信息 -->
                    <div class="form-section" v-if="LockData.teachers && LockData.teachers.length">
                        <div class="section-title">师资信息</div>
                        <el-table :data="LockData.teachers" border style="width: 100%">
                            <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                            <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                            <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                            <el-table-column label="职称/资质证明" width="140">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.qualification_cert" type="text" @click="OpenLock(scope.row.qualification_cert)">查看PDF</el-button>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="授课协议" width="120">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.teaching_agreement" type="text" @click="OpenLock(scope.row.teaching_agreement)">查看PDF</el-button>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 管理团队 -->
                    <div class="form-section" v-if="LockData.team && LockData.team.length">
                        <div class="section-title">项目管理团队</div>
                        <el-table :data="LockData.team" border style="width: 100%">
                            <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                            <el-table-column prop="education_background" label="教育背景" width="180"></el-table-column>
                            <el-table-column label="劳动合同/社保证明" width="160">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.labor_contract" type="text" @click="OpenLock(scope.row.labor_contract)">查看PDF</el-button>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="other" label="其他"></el-table-column>
                        </el-table>
                    </div>

                    <div class="form-section" v-if="LockData.training_program">
                        <div class="section-title">培训方案与学员管理制度</div>
                        <el-button type="primary" size="small" @click="OpenLock(LockData.training_program)">查看PDF</el-button>
                    </div>
                    <div class="form-section" v-if="LockData.assessment_plan">
                        <div class="section-title">考核评价方案及结业标准</div>
                        <el-button type="primary" size="small" @click="OpenLock(LockData.assessment_plan)">查看PDF</el-button>
                    </div>
                    <div class="form-section" v-if="LockData.last_experience">
                        <div class="section-title">过往项目经验及学员反馈材料</div>
                        <el-button type="primary" size="small" @click="OpenLock(LockData.last_experience)">查看PDF</el-button>
                    </div>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="PublishSuc" v-if="((!LockBlon && !LockData.user_group_id) || educationEditMode)">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 继续教育项目申请弹窗 -->
        <el-dialog :visible.sync="imageDialogVisible" :width="Wid" :show-close="true" title="继续教育项目申请" top="5vh" @close="closeImageDialog">
            <div class="image-project-form">
                <div class="form-tip">
                    温馨提醒：填报继续教育项目前请先阅读
                    <a href="https://rps.camh.org.cn/#/InfoDetail?id=16&type=5" target="_blank">《继续教育项目管理细则》</a>
                </div>

                <div class="form-section">
                    <div class="section-title">基础信息</div>
                    <el-form :model="imageProjectForm" label-width="120px">
                        <el-form-item label="机构名称" required>
                            <el-input v-model="companyName" disabled placeholder="取自专业机构注册名称"></el-input>
                        </el-form-item>
                        <el-form-item label="项目名称" required>
                            <el-input v-model="imageProjectForm.title" placeholder="请输入项目名称"></el-input>
                        </el-form-item>
                        <el-form-item label="项目类型" required>
                            <el-radio-group v-model="imageProjectForm.courseCategory" class="option-radio-group">
                                <el-radio label="1" border>专业基础课程</el-radio>
                                <el-radio label="2" border>专业进阶课程</el-radio>
                                <el-radio label="3" border>专业专题课程</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="授课类型" required>
                            <el-radio-group v-model="imageProjectForm.teachingType" class="option-radio-group">
                                <el-radio label="2" border>线下</el-radio>
                                <el-radio label="3" border>线上线下结合</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="项目周期" required>
                            <el-date-picker
                                v-model="imageProjectForm.dateRange"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="项目申请表" required>
                            <div class="pdf-upload-wrap">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'project_application', 'projectApplicationFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="small" type="primary">{{ imageProjectForm.project_application ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="imageProjectForm.project_application" type="text" size="small" @click="OpenLock(imageProjectForm.project_application)">查看</el-button>
                                </div>
                                <div class="upload-tip">含可行性论证，须按行业需求、学员分析、差异化优势、资源配套四个维度分项阐述</div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">课程大纲</div>
                    <el-table :data="imageProjectForm.courses" border style="width: 100%">
                        <el-table-column label="课程模块" width="150">
                            <template slot="header"><span class="required-label">课程模块</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.module" placeholder="课程模块"></el-input></template>
                        </el-table-column>
                        <el-table-column label="教学目标" width="150">
                            <template slot="header"><span class="required-label">教学目标</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.objective" placeholder="教学目标"></el-input></template>
                        </el-table-column>
                        <el-table-column label="课程内容" width="150">
                            <template slot="header"><span class="required-label">课程内容</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.content" placeholder="课程内容"></el-input></template>
                        </el-table-column>
                        <el-table-column label="讲师" width="100">
                            <template slot="header"><span class="required-label">讲师</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.teacher" placeholder="讲师"></el-input></template>
                        </el-table-column>
                        <el-table-column label="课时" width="110">
                            <template slot="header"><span class="required-label">课时</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.hours" placeholder="课时" type="number" min="0" @input="scope.row.hours = String(scope.row.hours || '').replace(/[^\d.]/g, '')"></el-input></template>
                        </el-table-column>
                        <el-table-column label="备注" width="120">
                            <template slot-scope="scope"><el-input v-model="scope.row.remark" placeholder="备注"></el-input></template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeCourse(scope.$index)" v-if="imageProjectForm.courses.length > 1">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-course-btn"><el-button type="primary" icon="el-icon-plus" @click="addCourse">添加课程</el-button></div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">师资信息</div>
                    <el-table :data="imageProjectForm.teachers" border style="width: 100%">
                        <el-table-column label="姓名" width="100">
                            <template slot="header"><span class="required-label">姓名</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.name" placeholder="姓名"></el-input></template>
                        </el-table-column>
                        <el-table-column label="所属单位" width="130">
                            <template slot="header"><span class="required-label">所属单位</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.company" placeholder="所属单位"></el-input></template>
                        </el-table-column>
                        <el-table-column label="专业领域" width="130">
                            <template slot="header"><span class="required-label">专业领域</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.specialty" placeholder="专业领域"></el-input></template>
                        </el-table-column>
                        <el-table-column label="职称/资质证明" width="180">
                            <template slot="header"><span class="required-label">职称/资质证明</span></template>
                            <template slot-scope="scope">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadTeacherPdf(p, scope.$index, 'qualification_cert')" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="mini" type="primary">{{ scope.row.qualification_cert ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="scope.row.qualification_cert" type="text" size="mini" @click="OpenLock(scope.row.qualification_cert)">查看</el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="授课协议" width="180">
                            <template slot="header"><span class="required-label">授课协议</span></template>
                            <template slot-scope="scope">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadTeacherPdf(p, scope.$index, 'teaching_agreement')" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="mini" type="primary">{{ scope.row.teaching_agreement ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="scope.row.teaching_agreement" type="text" size="mini" @click="OpenLock(scope.row.teaching_agreement)">查看</el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="70">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeTeacher(scope.$index)" v-if="imageProjectForm.teachers.length > 1">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-course-btn"><el-button type="primary" icon="el-icon-plus" @click="addTeacher">添加师资</el-button></div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">培训方案与学员管理制度</div>
                    <div class="pdf-upload-wrap">
                        <div class="upload-action-row">
                            <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'training_program', 'trainingProgramFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                <el-button size="small" type="primary">{{ imageProjectForm.training_program ? '重新上传' : '上传PDF' }}</el-button>
                            </el-upload>
                            <el-button v-if="imageProjectForm.training_program" type="text" size="small" @click="OpenLock(imageProjectForm.training_program)">查看</el-button>
                        </div>
                        <div class="upload-tip">涵盖报名审核、考勤、权益保障、投诉受理渠道等</div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">考核评价方案及结业标准</div>
                    <div class="pdf-upload-wrap">
                        <div class="upload-action-row">
                            <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'assessment_plan', 'assessmentPlanFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                <el-button size="small" type="primary">{{ imageProjectForm.assessment_plan ? '重新上传' : '上传PDF' }}</el-button>
                            </el-upload>
                            <el-button v-if="imageProjectForm.assessment_plan" type="text" size="small" @click="OpenLock(imageProjectForm.assessment_plan)">查看</el-button>
                        </div>
                        <div class="upload-tip">含考核方式、评分标准、补考机制、学时认定条件等</div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">项目管理团队构成</div>
                    <div class="upload-tip section-hint">团队须不少于2人，负责人须具备心理学、教育学或管理相关教育背景</div>
                    <el-table :data="imageProjectForm.team" border style="width: 100%">
                        <el-table-column label="姓名" width="100">
                            <template slot="header"><span class="required-label">姓名</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.name" placeholder="姓名"></el-input></template>
                        </el-table-column>
                        <el-table-column label="教育背景" width="150">
                            <template slot="header"><span class="required-label">教育背景</span></template>
                            <template slot-scope="scope"><el-input v-model="scope.row.education_background" placeholder="教育背景"></el-input></template>
                        </el-table-column>
                        <el-table-column label="劳动合同/社保证明" width="200">
                            <template slot="header"><span class="required-label">劳动合同/社保证明</span></template>
                            <template slot-scope="scope">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadTeamPdf(p, scope.$index)" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="mini" type="primary">{{ scope.row.labor_contract ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="scope.row.labor_contract" type="text" size="mini" @click="OpenLock(scope.row.labor_contract)">查看</el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="其他" width="120">
                            <template slot-scope="scope"><el-input v-model="scope.row.other" placeholder="其他"></el-input></template>
                        </el-table-column>
                        <el-table-column label="操作" width="70">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeTeamMember(scope.$index)" v-if="imageProjectForm.team.length > 2">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-course-btn"><el-button type="primary" icon="el-icon-plus" @click="addTeamMember">添加成员</el-button></div>
                </div>

                <div class="form-section">
                    <div class="section-title">收费情况</div>
                    <el-form :model="imageProjectForm" label-width="120px">
                        <el-form-item label="收费标准" required>
                            <el-input v-model="imageProjectForm.fee" placeholder="请输入金额" style="width:200px">
                                <template slot="append">元/人</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="成本构成说明" required>
                            <div class="pdf-upload-wrap">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'cost_structure', 'costStructureFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="small" type="primary">{{ imageProjectForm.cost_structure ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="imageProjectForm.cost_structure" type="text" size="small" @click="OpenLock(imageProjectForm.cost_structure)">查看</el-button>
                                </div>
                                <div class="upload-tip">师资成本、场地/平台成本、资料成本、管理成本等占比</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="退费机制说明" required>
                            <div class="pdf-upload-wrap">
                                <div class="upload-action-row">
                                    <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'refund_policy', 'refundPolicyFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                        <el-button size="small" type="primary">{{ imageProjectForm.refund_policy ? '重新上传' : '上传PDF' }}</el-button>
                                    </el-upload>
                                    <el-button v-if="imageProjectForm.refund_policy" type="text" size="small" @click="OpenLock(imageProjectForm.refund_policy)">查看</el-button>
                                </div>
                                <div class="upload-tip">开课前退费比例、开课后退费比例、不予退费情形</div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">应急预案与风险管控方案</div>
                    <div class="pdf-upload-wrap">
                        <div class="upload-action-row">
                            <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'emergency_plan', 'emergencyPlanFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                <el-button size="small" type="primary">{{ imageProjectForm.emergency_plan ? '重新上传' : '上传PDF' }}</el-button>
                            </el-upload>
                            <el-button v-if="imageProjectForm.emergency_plan" type="text" size="small" @click="OpenLock(imageProjectForm.emergency_plan)">查看</el-button>
                        </div>
                        <div class="upload-tip">须覆盖重大舆情、学员集中投诉、商业秘密泄露三类情形的处置流程</div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">过往项目经验及学员反馈材料</div>
                    <div class="pdf-upload-wrap">
                        <div class="upload-action-row">
                            <el-upload action="none" :show-file-list="false" :http-request="(p) => uploadProjectPdf(p, 'last_experience', 'lastExperienceFileList')" :before-upload="beforePdfUpload" accept=".pdf">
                                <el-button size="small" type="primary">{{ imageProjectForm.last_experience ? '重新上传' : '上传PDF' }}</el-button>
                            </el-upload>
                            <el-button v-if="imageProjectForm.last_experience" type="text" size="small" @click="OpenLock(imageProjectForm.last_experience)">查看</el-button>
                        </div>
                        <div class="upload-tip">含项目总结、满意度调查、培训成效证明等</div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title is-required">机构资质承诺书</div>
                    <el-checkbox v-model="imageProjectForm.promise_independent">本人承诺本项目由本机构独立实施，不授权、不转包、不分包给任何二级机构或其他单位。</el-checkbox>
                    <el-checkbox v-model="imageProjectForm.promise_truth" style="display:block;margin-top:10px;">本人承诺所提交的全部申请材料真实有效，如有虚假，愿承担相应责任并接受3年内不得再次申请的处罚。</el-checkbox>
                </div>

                <div class="form-footer">
                    <el-button @click="closeImageDialog">取消</el-button>
                    <el-button type="primary" @click="submitImageProject">{{ imageEditMode ? '保存' : '提交' }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
export default {
    components: { quillEditor },
    data() {
        return {
            Wid: "60%",
            Data: [],
            LockData: "",
            LockBlon: false,
            total: 0,
            page: 1,
            SizePage: 10,
            PublishBlon: false,
            showProjectBtn: false,
            showTypeDialog: false,
            selectedProjectType: null,
            userGroups: [],
            SetData: {
                content: "",
                img: "",
                projects_type_id: "",
                title: "",
                synopsis: "",
                start_time: ""
            },
            editorOption: this.$Global.CommEditor,
            projectsTypeList: [],
            imageDialogVisible: false,
            companyName: '',
            projectApplicationFileList: [],
            trainingProgramFileList: [],
            assessmentPlanFileList: [],
            costStructureFileList: [],
            refundPolicyFileList: [],
            emergencyPlanFileList: [],
            lastExperienceFileList: [],
            editingProjectId: null,
            educationEditMode: false,
            imageEditMode: false,
            imageProjectForm: {
                title: '',
                courseCategory: '',
                teachingType: '',
                dateRange: [],
                project_application: '',
                fee: '',
                cost_structure: '',
                refund_policy: '',
                emergency_plan: '',
                last_experience: '',
                training_program: '',
                assessment_plan: '',
                promise_independent: false,
                promise_truth: false,
                courses: [{
                    module: '',
                    objective: '',
                    content: '',
                    teacher: '',
                    hours: '',
                    remark: ''
                }],
                teachers: [{
                    name: '',
                    company: '',
                    specialty: '',
                    qualification_cert: '',
                    teaching_agreement: '',
                }],
                team: [
                    { name: '', education_background: '', labor_contract: '', other: '' },
                    { name: '', education_background: '', labor_contract: '', other: '' },
                ],
            },
            statusMap: {
                '0': '待提交',
                '1': '待缴费',
                '2': '待审核',
                '3': '已驳回',
                '4': '待审核',
                '5': '已驳回',
                '6': '完成'
            },
        }
    },
    mounted() {
        this.Wid = this.$Global._isMobile() ? "95%" : "80%";
        this.GetData();
        // this.ProjectsType();
        this.checkUserGroup();
    },
    methods: {
        GetData() {
            this.$post("api/user/projectList", {
                page: this.page,
                limit: this.SizePage,
            }).then(res => {
                if (res.data.code == 1) {
                    this.total = res.data.data.total;
                    this.Data = res.data.data.data;
                }
            })
        },
        ProjectsType() {
            this.$get("api/index/projectsType").then(res => {
                if (res.data.code == 1) {
                    this.projectsTypeList = res.data.data;
                }
            })
        },
        ToggleLock(res) {
            this.LockData = res;
            this.LockBlon = true;
            this.Toggle();
            console.log(this.LockData)
        },
        Toggle() {
            this.PublishBlon = !this.PublishBlon;
        },
        PublishSuc() {
            // 学历教育项目的请求体
            const formData = new FormData();
            
            // 添加基本信息到row
            formData.append('row[title]', this.SetData.title); // 专业名称
            formData.append('row[synopsis]', this.SetData.synopsis); // 专业介绍
            formData.append('row[start_date]', this.formatDate(this.SetData.start_time)); // 开始时间
            formData.append('row[img]', this.SetData.img); // 文件上传url
            formData.append('row[user_group_id]', "6"); // 学历教育项目
            formData.append('row[content]', this.SetData.content || ''); // 内容
            if (this.educationEditMode && this.editingProjectId) {
                formData.append('row[id]', this.editingProjectId);
            }
            
            const api = this.educationEditMode ? "api/user/editProject" : "api/user/addProject";
            this.$post(api, formData).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg)
                    this.GetData();
                    this.handleCancel();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        UpFile(res) {
            var file = res.file;
            var fd = new FormData()
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                this.SetData.img = res.data.url;
            })
        },
        OpenLock(res) {
            this.$Global.previewFile(res);
        },
        SizeChange(val) {
            this.SizePage = val;
            this.GetData();
        },
        PageChange(val) {
            this.page = val;
            this.GetData();
        },
        checkUserGroup() {
            this.$post("api/user/getUserInfo")
            .then(res => {
                if (res.data.code == 1) {
                    const userGroup = res.data.data.company_user_group || [];
                    this.userGroups = userGroup;
                    this.companyName = res.data.data.company_name || '';
                    this.showProjectBtn = userGroup.includes(6) || userGroup.includes(7);
                }
            });
        },
        resetNewProjectState() {
            this.imageEditMode = false;
            this.educationEditMode = false;
            this.editingProjectId = null;
            this.LockData = '';
            this.LockBlon = false;
            this.SetData = {
                content: '',
                img: '',
                projects_type_id: '',
                title: '',
                synopsis: '',
                start_time: ''
            };
        },
        handleProjectClick() {
            this.resetNewProjectState();
            if (this.userGroups.includes(6) && this.userGroups.includes(7)) {
                // 同时有权限6和7，显示选择弹窗
                this.showTypeDialog = true;
            } else if (this.userGroups.includes(7)) {
                // 只有权限7，直接显示继续教育项目弹窗
                this.showImageDialog();
            } else if (this.userGroups.includes(6)) {
                // 只有权限6，直接显示学历教育项目弹窗
                this.Toggle();
            }
        },
        handleTypeSelect() {
            this.showTypeDialog = false;
            this.resetNewProjectState();
            if (this.selectedProjectType === 6) {
                // 选择了学历教育项目
                this.Toggle();
            } else if (this.selectedProjectType === 7) {
                // 选择了继续教育项目
                this.showImageDialog();
            }
        },
        showImageDialog() {
            this.resetImageProjectForm();
            this.imageDialogVisible = true;
        },
        resetImageProjectForm() {
            this.imageProjectForm = {
                title: '',
                courseCategory: '',
                teachingType: '',
                dateRange: [],
                project_application: '',
                fee: '',
                cost_structure: '',
                refund_policy: '',
                emergency_plan: '',
                last_experience: '',
                training_program: '',
                assessment_plan: '',
                promise_independent: false,
                promise_truth: false,
                courses: [{ module: '', objective: '', content: '', teacher: '', hours: '', remark: '' }],
                teachers: [{ name: '', company: '', specialty: '', qualification_cert: '', teaching_agreement: '' }],
                team: [
                    { name: '', education_background: '', labor_contract: '', other: '' },
                    { name: '', education_background: '', labor_contract: '', other: '' },
                ],
            };
            this.projectApplicationFileList = [];
            this.trainingProgramFileList = [];
            this.assessmentPlanFileList = [];
            this.costStructureFileList = [];
            this.refundPolicyFileList = [];
            this.emergencyPlanFileList = [];
            this.lastExperienceFileList = [];
        },
        beforePdfUpload(file) {
            const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isPdf) {
                this.$message.error('仅支持上传PDF格式文件');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('文件大小不能超过10MB');
                return false;
            }
            return true;
        },
        uploadProjectPdf(params, field, listKey) {
            const file = params.file;
            const fd = new FormData();
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                if (res.code === 1) {
                    this.imageProjectForm[field] = res.data.url;
                    this[listKey] = [{ name: file.name, url: res.data.url }];
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            });
        },
        removeProjectPdf(field, listKey) {
            this.imageProjectForm[field] = '';
            this[listKey] = [];
        },
        uploadTeacherPdf(params, index, field) {
            const file = params.file;
            const fd = new FormData();
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                if (res.code === 1) {
                    this.$set(this.imageProjectForm.teachers[index], field, res.data.url);
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            });
        },
        uploadTeamPdf(params, index) {
            const file = params.file;
            const fd = new FormData();
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                if (res.code === 1) {
                    this.$set(this.imageProjectForm.team[index], 'labor_contract', res.data.url);
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            });
        },
        validateImageProject() {
            const f = this.imageProjectForm;
            if (!this.companyName) return this.$message.error('未获取到机构注册名称，请先完成专业机构注册'), false;
            if (!f.title) return this.$message.error('请输入项目名称'), false;
            if (!f.courseCategory) return this.$message.error('请选择项目类型'), false;
            if (!f.teachingType) return this.$message.error('请选择授课类型'), false;
            if (!f.dateRange || !f.dateRange.length) return this.$message.error('请选择项目周期'), false;
            if (!f.project_application) return this.$message.error('请上传项目申请表'), false;

            const completeCourses = f.courses.filter(c => c.module && c.objective && c.content && c.teacher && c.hours);
            if (completeCourses.length < 1) return this.$message.error('请至少完整填写一条课程大纲'), false;
            for (let i = 0; i < f.courses.length; i++) {
                const c = f.courses[i];
                const hasAny = c.module || c.objective || c.content || c.teacher || c.hours || c.remark;
                if (hasAny && !(c.module && c.objective && c.content && c.teacher && c.hours)) {
                    return this.$message.error(`请完整填写第${i + 1}条课程大纲（备注除外）`), false;
                }
            }

            const completeTeachers = f.teachers.filter(t => t.name && t.company && t.specialty && t.qualification_cert && t.teaching_agreement);
            if (completeTeachers.length < 1) return this.$message.error('请至少完整填写一条师资信息（含PDF）'), false;
            for (let i = 0; i < f.teachers.length; i++) {
                const t = f.teachers[i];
                const hasAny = t.name || t.company || t.specialty || t.qualification_cert || t.teaching_agreement;
                if (hasAny && !(t.name && t.company && t.specialty && t.qualification_cert && t.teaching_agreement)) {
                    return this.$message.error(`请完整填写第${i + 1}位师资信息（含职称/资质证明、授课协议PDF）`), false;
                }
            }

            if (!f.training_program) return this.$message.error('请上传培训方案与学员管理制度'), false;
            if (!f.assessment_plan) return this.$message.error('请上传考核评价方案及结业标准'), false;

            for (let i = 0; i < f.team.length; i++) {
                const m = f.team[i];
                const hasAny = m.name || m.education_background || m.labor_contract || m.other;
                if (hasAny && !(m.name && m.education_background && m.labor_contract)) {
                    return this.$message.error(`请完整填写第${i + 1}位团队成员信息（姓名、教育背景、劳动合同/社保证明为必填）`), false;
                }
            }
            const completeTeam = f.team.filter(m => m.name && m.education_background && m.labor_contract);
            if (completeTeam.length < 2) return this.$message.error('项目管理团队须不少于2人，且每人须填写姓名、教育背景并上传劳动合同/社保证明'), false;

            if (!f.fee) return this.$message.error('请输入收费标准'), false;
            if (!f.cost_structure) return this.$message.error('请上传成本构成说明'), false;
            if (!f.refund_policy) return this.$message.error('请上传退费机制说明'), false;
            if (!f.emergency_plan) return this.$message.error('请上传应急预案与风险管控方案'), false;
            if (!f.last_experience) return this.$message.error('请上传过往项目经验及学员反馈材料'), false;
            if (!f.promise_independent || !f.promise_truth) return this.$message.error('请勾选机构资质承诺书'), false;
            return true;
        },
        submitImageProject() {
            if (!this.validateImageProject()) return;

            const formData = new FormData();
            const f = this.imageProjectForm;

            formData.append('row[title]', f.title);
            formData.append('row[course_category]', f.courseCategory);
            formData.append('row[project_type]', f.teachingType);
            formData.append('row[start_date]', f.dateRange[0] ? this.formatDate(f.dateRange[0]) : '');
            formData.append('row[end_date]', f.dateRange[1] ? this.formatDate(f.dateRange[1]) : '');
            formData.append('row[project_application]', f.project_application);
            formData.append('row[fee]', f.fee);
            formData.append('row[cost_structure]', f.cost_structure);
            formData.append('row[refund_policy]', f.refund_policy);
            formData.append('row[emergency_plan]', f.emergency_plan);
            formData.append('row[last_experience]', f.last_experience);
            formData.append('row[training_program]', f.training_program);
            formData.append('row[assessment_plan]', f.assessment_plan);
            formData.append('row[promise_independent]', f.promise_independent ? 1 : 0);
            formData.append('row[promise_truth]', f.promise_truth ? 1 : 0);
            formData.append('row[user_group_id]', '7');
            formData.append('row[synopsis]', '');
            if (this.imageEditMode && this.editingProjectId) {
                formData.append('row[id]', this.editingProjectId);
            }

            const completeCourses = f.courses.filter(c => c.module && c.objective && c.content && c.teacher && c.hours);
            completeCourses.forEach((course, index) => {
                formData.append(`courses[${index}][course_module]`, course.module);
                formData.append(`courses[${index}][teaching_objective]`, course.objective);
                formData.append(`courses[${index}][content]`, course.content);
                formData.append(`courses[${index}][teacher]`, course.teacher);
                formData.append(`courses[${index}][hours]`, course.hours);
                formData.append(`courses[${index}][remark]`, course.remark || '');
            });

            const completeTeachers = f.teachers.filter(t => t.name && t.company && t.specialty && t.qualification_cert && t.teaching_agreement);
            completeTeachers.forEach((teacher, index) => {
                formData.append(`teachers[${index}][name]`, teacher.name);
                formData.append(`teachers[${index}][company]`, teacher.company);
                formData.append(`teachers[${index}][specialty]`, teacher.specialty);
                formData.append(`teachers[${index}][qualification_cert]`, teacher.qualification_cert);
                formData.append(`teachers[${index}][teaching_agreement]`, teacher.teaching_agreement);
            });

            const completeTeam = f.team.filter(m => m.name && m.education_background && m.labor_contract);
            completeTeam.forEach((member, index) => {
                formData.append(`team[${index}][name]`, member.name);
                formData.append(`team[${index}][education_background]`, member.education_background);
                formData.append(`team[${index}][labor_contract]`, member.labor_contract);
                formData.append(`team[${index}][other]`, member.other || '');
            });

            const api = this.imageEditMode ? 'api/user/editProject' : 'api/user/addProject';
            this.$post(api, formData).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.closeImageDialog();
                    this.GetData();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        handleEdit(row) {
            this.editingProjectId = row.id;
            if (row.user_group_id === 6) {
                this.educationEditMode = true;
                this.imageEditMode = false;
                this.LockData = { user_group_id: 6 };
                this.LockBlon = false;
                this.SetData = {
                    ...this.SetData,
                    title: row.title || '',
                    synopsis: row.synopsis || '',
                    start_time: row.start_date || '',
                    img: row.img || '',
                    content: row.content || '',
                };
                this.PublishBlon = true;
                return;
            }
            if (row.user_group_id === 7) {
                this.imageEditMode = true;
                this.educationEditMode = false;
                this.fillImageProjectForm(row);
                this.imageDialogVisible = true;
            }
        },
        fillImageProjectForm(row) {
            this.imageProjectForm.title = row.title || '';
            this.imageProjectForm.courseCategory = String(row.course_category || '');
            this.imageProjectForm.teachingType = String(row.project_type || '');
            this.imageProjectForm.dateRange = [row.start_date || '', row.end_date || ''];
            this.imageProjectForm.project_application = row.project_application || '';
            this.imageProjectForm.fee = row.fee || '';
            this.imageProjectForm.cost_structure = row.cost_structure || '';
            this.imageProjectForm.refund_policy = row.refund_policy || '';
            this.imageProjectForm.emergency_plan = row.emergency_plan || '';
            this.imageProjectForm.last_experience = row.last_experience || '';
            this.imageProjectForm.training_program = row.training_program || '';
            this.imageProjectForm.assessment_plan = row.assessment_plan || '';
            this.imageProjectForm.promise_independent = !!Number(row.promise_independent);
            this.imageProjectForm.promise_truth = !!Number(row.promise_truth);

            this.projectApplicationFileList = this.makePdfFileList(row.project_application, '项目申请表.pdf');
            this.trainingProgramFileList = this.makePdfFileList(row.training_program, '培训方案.pdf');
            this.assessmentPlanFileList = this.makePdfFileList(row.assessment_plan, '考核评价方案.pdf');
            this.costStructureFileList = this.makePdfFileList(row.cost_structure, '成本构成说明.pdf');
            this.refundPolicyFileList = this.makePdfFileList(row.refund_policy, '退费机制说明.pdf');
            this.emergencyPlanFileList = this.makePdfFileList(row.emergency_plan, '应急预案.pdf');
            this.lastExperienceFileList = this.makePdfFileList(row.last_experience, '过往项目经验.pdf');

            this.imageProjectForm.courses = (row.course || row.courses || []).map(course => ({
                module: course.course_module || '',
                objective: course.teaching_objective || '',
                content: course.content || '',
                teacher: course.teacher || '',
                hours: course.hours || '',
                remark: course.remark || '',
            }));
            if (!this.imageProjectForm.courses.length) this.addCourse();

            this.imageProjectForm.teachers = (row.teachers || []).map(teacher => ({
                name: teacher.name || '',
                company: teacher.company || '',
                specialty: teacher.specialty || '',
                qualification_cert: teacher.qualification_cert || '',
                teaching_agreement: teacher.teaching_agreement || '',
            }));
            if (!this.imageProjectForm.teachers.length) this.addTeacher();

            this.imageProjectForm.team = (row.team || []).map(member => ({
                name: member.name || '',
                education_background: member.education_background || '',
                labor_contract: member.labor_contract || '',
                other: member.other || '',
            }));
            while (this.imageProjectForm.team.length < 2) this.addTeamMember();
        },
        makePdfFileList(url, name) {
            return url ? [{ name, url }] : [];
        },
        closeImageDialog() {
            this.imageDialogVisible = false;
            this.imageEditMode = false;
            this.editingProjectId = null;
            this.resetImageProjectForm();
        },
        // 格式化日期为 yyyy-MM-dd
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        addCourse() {
            this.imageProjectForm.courses.push({
                module: '',
                objective: '',
                content: '',
                teacher: '',
                hours: '',
                remark: ''
            });
        },
        removeCourse(index) {
            this.imageProjectForm.courses.splice(index, 1);
        },
        addTeacher() {
            this.imageProjectForm.teachers.push({
                name: '',
                company: '',
                specialty: '',
                qualification_cert: '',
                teaching_agreement: '',
            });
        },
        removeTeacher(index) {
            this.imageProjectForm.teachers.splice(index, 1);
        },
        addTeamMember() {
            this.imageProjectForm.team.push({
                name: '',
                education_background: '',
                labor_contract: '',
                other: '',
            });
        },
        removeTeamMember(index) {
            this.imageProjectForm.team.splice(index, 1);
        },
        getStatusType(status) {
            const typeMap = {
                '0': 'info',      // 待提交 - 灰色
                '1': 'warning',   // 待缴费 - 黄色
                '2': 'primary',   // 形式待审核 - 蓝色
                '3': 'danger',    // 形式已驳回 - 红色
                '4': 'primary',   // 专家待审核 - 蓝色
                '5': 'danger',    // 专家已驳回 - 红色
                '6': 'success'    // 完成 - 绿色
            }
            return typeMap[status] || 'info'
        },
        getStatusText(status) {
            return this.statusMap[status] || '未知状态'
        },
        getProjectTypeText(type) {
            const typeMap = {
                '1': '线上',
                '2': '线下',
                '3': '线上线下结合',
            };
            return typeMap[String(type)] || '未知';
        },
        getCourseCategoryText(type) {
            const typeMap = {
                '1': '专业基础课程',
                '2': '专业进阶课程',
                '3': '专业专题课程',
            };
            return typeMap[String(type)] || '未知';
        },
        handleCancel() {
            this.PublishBlon = false;
            this.LockData = "";
            this.educationEditMode = false;
            this.editingProjectId = null;
        },
    },
}
</script>
<style>
.Wid500 .ql-editor {
    height: 150px;
    /* 设置编辑器的高度 */
}
</style>
<style scoped>
.Wid500 {
    width: calc(100% - 85px) !important;
    max-width: 100%;
}

.InfoTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
}

.InfoTopBtn {
    padding: 5px 20px;
    background: #FFFFFF;
    font-weight: 400;
    font-size: 18px;
    color: #0385EB;
    border-radius: 5px;
    border: 2px solid #0385EB;
    margin-right: 20px;
    cursor: pointer;
}

.InfoTopBtn.BgBlue {
    background: #0385EB;
    color: #fff;
}

.PublishCont {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
}

.PublishItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.PublishItem .Title {
    color: #027cfb;
    font-size: 16px;
    font-weight: 400;
}

.PublishItem .Time {
    color: #666;
    font-size: 14px;
}

.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.StepCommFileBtn {
    font-size: 16px;
    padding: 3px 35px;
    background: #F5F5F5;
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    text-align: center;
    cursor: pointer;
}

.StepCommFileLock {
    font-size: 16px;
    color: #0385EB;
    padding: 0 10px;
}

.CommDig {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-height: 80vh;
    overflow-y: auto;
    padding: 20px;
}

.CommDig > div {
    width: 100%;
    max-width: 100%;
}

.DigItem {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    width: 100%;
}

.DigItem .DigTit {
    font-size: 16px;
    color: #000000;
    margin-right: 20px;
    min-width: 65px;
    flex-shrink: 0;
}

.DigItem input,
.DigItem textarea,
.DigItem .el-select {
    width: calc(100% - 85px);
    max-width: 100%;
    border-radius: 10px;
    border: solid 1px #e1e1e1;
    padding: 15px;
    outline: none;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 10px;
    border: solid 1px #d6e5ff;
    font-size: 16px;
    color: #2354f4;
    padding: 10px 40px;
    cursor: pointer;
}

.DigBtns .Btn:hover {
    box-shadow: 0 0 10px #b6d0ed;
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
}

.LockImg {
    width: 40px;
    height: 40px;
}

.project-type-select {
    text-align: center;
    padding: 20px 0;
}

.image-project-form {
    padding: 20px;
}

.form-section {
    margin-bottom: 30px;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 4px solid #409EFF;
}

.section-title.is-required::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}

.required-label::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}

.image-project-form .el-form-item {
    margin-bottom: 20px;
}

.image-project-form .el-input,
.image-project-form .el-date-picker {
    width: 100%;
}

.image-project-form .option-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
}

.image-project-form .option-radio-group .el-radio.is-bordered {
    margin: 0;
    padding: 10px 20px;
    height: auto;
    line-height: 1.5;
}

.image-project-form .option-radio-group .el-radio.is-bordered.is-checked {
    border-color: #0385EB;
    background-color: #ecf5ff;
}

.image-project-form .option-radio-group .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
}

.add-course-btn {
    margin-top: 20px;
    text-align: center;
}

.form-footer {
    text-align: center;
    margin-top: 30px;
}

.form-footer .el-button {
    padding: 12px 40px;
    margin: 0 10px;
}

@media only screen and (max-width: 550px) {
    .image-project-form {
        padding: 10px;
    }
    
    .image-project-form .el-form-item {
        margin-bottom: 15px;
    }
    
    .image-project-form .option-radio-group {
        flex-direction: column;
    }

    .image-project-form .option-radio-group .el-radio.is-bordered {
        width: 100%;
    }
}

.form-tip {
    background: #f0f9ff;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 20px;
    color: #606266;
    font-size: 14px;
}
.form-tip a {
    color: #409EFF;
    text-decoration: none;
}
.upload-tip {
    color: #909399;
    font-size: 12px;
    margin-top: 8px;
    line-height: 1.5;
}
.section-hint {
    margin-bottom: 12px;
}
.pdf-upload-wrap {
    width: 100%;
}
.upload-action-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}
.upload-action-row .el-upload {
    display: inline-block;
}

.dialog-footer {
    text-align: center;
    padding: 20px 0;
    margin-top: 20px;
    border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
    padding: 10px 30px;
    font-size: 14px;
}

.upload-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.StepCommFileBtn {
    font-size: 14px;
    padding: 8px 20px;
    background: #F5F5F5;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
}

.StepCommFileBtn:hover {
    background: #EBEEF5;
}

.StepCommFileLock {
    font-size: 14px;
    color: #409EFF;
    cursor: pointer;
}

.StepCommFileLock:hover {
    color: #66b1ff;
}

.experience-files {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 10px 0;
}

.experience-file {
    position: relative;
}

.experience-file .LockImg {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    cursor: pointer;
    transition: all 0.3s;
}

.experience-file .LockImg:hover {
    border-color: #409EFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>